import {
  Component,
  OnInit,
  NgZone,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthservicesService } from 'src/app/services/authservices.service';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import {
CountryISO,
} from 'ngx-intl-tel-input';
import { Router } from '@angular/router';
declare const google: any;
@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.css'],
})
export class BasicInfoComponent implements OnInit {
  arr = [1, 2, 3];
  form: FormGroup;
  show = 0;
  communitySearch;
  address;
  currentForm;
  submitted = false;
  errorMessage;
  emailMessage;
  modalRef: BsModalRef;
  Title: string;
  faithResults: any[];
  communityResults: any[];
  loading = false;
  disabled = false;
  totalItems;
  checkbox = [];
  // Track selected affiliated communities as array of { community: string, isApproved: boolean }
  selectedassociatedBy: { community: string; isApproved: boolean }[] = [];
  loadMoreArr = [];
  showButton = false;
  communityName = '';
  faithName = '';
  pageSize;
  modalError;
  closeResult: string;
  staticButton;
  staticName = '';
  showError = false;
  coverPhoto;
  faithid;
  profilePic;
  value1;
  affilatedById;
  profitType;
  communityData: any;
  currentUser;
  modalOptions: NgbModalOptions;
  primaryFunction;
  countryList = [];
  formKey;
  fetchcommunityData;
  phoneError = true;
  secondPhone = true;
  thirdPhone = true;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  faithList: any;
  selectedFaith: string = '';
  selectedBranch = null;
  selectedDenomination = null;
  faithBranches: any = [];
  faithDenominations: any = [];
  allCommunityListing: any;
  selectedMinistry: string = '';
  subMininstryList: any;
  loadMoreCount: number = 10;
  searchTerm: string = ""


  constructor(
    private fb: FormBuilder,
    private zone: NgZone,
    private modalService: NgbModal,
    private authService: AuthservicesService,
    private router: Router
  ) {
    this.pageSize = 10;
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'));
    this.getCommunityData();
    this.getCommunityId(this.currentUser);

    this.errorMessage = environment.errorMessage;
    this.emailMessage = environment.emailMessage;
    this.primaryFunction = environment.primaryFunction;
    this.countryList = environment.countryList;

    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      communityUserName: ['', [Validators.required, this.noWhitespaceOrSpecialCharacter]],
      logLine: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(10),
        ],
      ],
      faith1Name: [''],
      faith2Name: [''],
      faith3Name: [''],
      faith: ['', Validators.required],
      subFaith: [null],
      subFaithSub: [null],
      // Will hold an array of objects: [{ community: string, isApproved: boolean }]
      associatedBy: [[]],
      certificateNo: [''],
      phone: [''],
      coverPhoto: [''],
      photo: [''],
      contactNo: ['', Validators.required],
      HotLinkContactNo: [''],
      publicEmail: ['', Validators.email],
      guideStarID: [''],
      bridgeNumber: [''],
      iosAppLink: [''],
      androidAppLink: [''],
      profitType: [[], Validators.required],
      subProfitType: [''],
      avgWeeklyAttendence: [''],
      countryOFReg: ['', Validators.required],
      website: ['']
    });

    // this.form.controls['faith1Name'].setValue("Christian");
    this.getFaith(0);
  }
  open(content:any, title:any) {
    this.Title = title;
    this.loading = false;
    this.loadMoreArr = [];
    this.checkbox.pop();
    // this.staticButton = false;
    if (title == 'faith') this.getFaith(0);
    if (title === 'What type of campus are you registering?') {
      this.showButton = false;
      this.loading = true;
      // this.staticButton = true;
      this.loadMoreArr.push(
        {
          name: 'Headquarters',
          photo: environment.staticImage,
          type: 'static',
        },
        {
          name: 'Satellite Campus',
          photo: environment.staticImage,
          type: 'static',
        }
      );
    }

    this.modalService.open(content, { scrollable: true }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  compareobj(obj) {
    let compare = false;
    if (obj) {
      for (let props in this.communityData) {
        for (let innerobj in obj) {
          if (this.communityName[props] == obj[innerobj]) {
            compare = true;
          } else {
            compare = false;
          }
        }
      }
    }
    return compare;
  }

  fetchData() {
    let CONTROL = this.form.controls;

    this.form.get('email').setValue(this.communityData.email);


    if (this.communityData.name != undefined) {
      for (const props in CONTROL) {

        CONTROL[props].patchValue(this.communityData[props]);

        if (props == 'photo' || props == 'coverPhoto') {
          this.profilePic = this.communityData[props];
          CONTROL[props].patchValue(this.communityData[props]);
        }

        if (props == 'coverPhoto') {
          this.coverPhoto = this.communityData[props];
          CONTROL[props].patchValue(this.communityData[props]);
        }

        if (props == 'faith') {
          this.faithName = this.communityData[props].name;
          CONTROL[props].patchValue(this.communityData[props]._id);
        }

        if (props == 'associatedBy' && this.communityData.community) {
          this.communityName = this.communityData[props].community['name'];
          this.form
            .get(props)
            .setValue(this.communityData[props]['community']['_id']);
        }
        if (props == 'associatedBy' && !this.communityData.community) {
          this.communityName = 'Member of Association';
        }
      }
      this.fetchcommunityData = this.form.value;
      this.form.controls['faith1Name'].setValue(this.communityData?.faith.name)

      this.selectedFaith = this.communityData?.faith._id;
      this.selectedBranch = this.communityData?.subFaith?._id;
      this.selectedDenomination = this.communityData?.subFaithSub?._id;
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  showMore() {
    const skip = this.loadMoreArr.length + this.loadMoreCount;
    this.getCommunity(skip);
    this.loadMoreCount += 10;
  }

  get f() {
    return this.form.controls;
  }

  getCommunityId(data) {
    let id;
    if (data) {
      id = this.currentUser.id;
    }

    this.authService.getCommunityByid(id).subscribe(
      (res: any) => {
        this.communityData = res.data;
        if (this.communityData) this.fetchData();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  difference(value) {
    let keyFound: any = false;
    let formobj = value;

    Object.keys(this.fetchcommunityData).forEach((key) => {
      if (this.fetchcommunityData[key] !== formobj[key]) {
        return (keyFound = key);
      }
    });
    return keyFound || -1;
  }

  onSubmit() {
    this.submitted = true;
    const isHQ = this.communityName === 'Headquarters';
    const isSatellite = this.communityName === 'Satellite Campus';

    // Only enforce associatedBy selection when Satellite Campus is chosen
    // Check selectedassociatedBy array which tracks the actual selections
    if (isSatellite && (!this.selectedassociatedBy || this.selectedassociatedBy.length === 0)) {
      this.showError = true;
      this.modalError = 'Please select at least one ministry.';
      // Mark the form control as invalid
      this.form.get('associatedBy').setErrors({ required: true });
      this.form.get('associatedBy').markAsTouched();
      return;
    }

    if (this.form.invalid) {
      return;
    }
    if (!this.phoneError || !this.secondPhone || !this.thirdPhone) {
      return;
    }
    if (this.fetchcommunityData) {
      let keyfound = this.difference(this.form.value);
      if (keyfound == -1 || keyfound == 'associatedBy') {
        this.router.navigate(['//user-registration/address']);
        return false;
      }
    }

    const formVal = this.form.value;

    // Normalize profitType to an array of string IDs in case objects were selected
    const profitTypeIds = Array.isArray(formVal.profitType)
      ? formVal.profitType
          .map((v: any) => (typeof v === 'string' ? v : (v?._id || v?.id)))
          .filter((x: any) => !!x)
      : [];

    // Parent HQ IDs from selectedassociatedBy when Satellite is chosen
    const parentHQIds = isSatellite ? (this.selectedassociatedBy || []).map(x => x.community) : [];

    const payload: any = {
      ...formVal,
      profitType: profitTypeIds,
      faithBranch: formVal.subFaith,
      faithDenomination: formVal.subFaithSub,
      profileType: isHQ ? 'headquarters' : (isSatellite ? 'satellite' : ''),
      parentHeadquarters: isSatellite ? parentHQIds.map(id => ({ id, status: 'pending' })) : [],
      isHeadquarters: !!isHQ,
    };

    // Remove internal helper fields so API only sees faith, faithBranch, faithDenomination
    delete payload.faith1Name;
    delete payload.faith2Name;
    delete payload.faith3Name;
    delete payload.subFaith;
    delete payload.subFaithSub;

    // Clean up associatedBy for non-satellite flow
    if (!isSatellite) {
      payload.associatedBy = [];
    }

    this.authService.signUpBaseInfo(payload).subscribe(
      (res: any) => {
        this.authService.successMessage(res.message, 'success');
        this.router.navigate(['/user-registration/address']);
      },
      (error) => {
        this.authService.successMessage(error.error.message, 'error');
        console.log(error);
      }
    );
  }

  clearValidtion(key) { }

  setValidation(key) {
    this.form.get(key).setValidators([Validators.required]);
    this.form.get(key).updateValueAndValidity();
  }

  getFaith(event: any) {
    this.showButton = true;
    const skip = event;
    const limit = 1000;
    this.authService.getFaith(skip, limit).subscribe(
      (res: any) => {
        this.loading = true;
        this.faithList = res?.data;
        this.totalItems = res.total;

        // On initial load, do not pre-populate branch/denomination.
        // These lists are filled by changeFaith / changeSubFaith when the user selects values.
        this.faithBranches = [];
        this.faithDenominations = [];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCommunity(event) {
    this.loadMoreArr = [];
    this.checkbox = [];
    let skip = event;
    this.authService.getCommunity(skip, this.pageSize, this.searchTerm).subscribe(
      (res: any) => {
        this.loading = true;
        this.communityResults = this.createArray(res.items, 'community');
        this.totalItems = res.total;
        this.concatArray(this.communityResults, this.totalItems);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  createArray(arr, type) {
    let data = [];
    arr.forEach((e: any) => {
      data.push({
        _id: e._id,
        name: e.name,
        photo: e.photo,
        description: !e.description ? e.shortBio : e.description,
        type: type,
      });
    });
    return data;
  }

  concatArray(arr, total) {
    if (arr.length != 0) {
      this.loadMoreArr = this.loadMoreArr.concat(arr);
    } else if (arr.length == 0) {
      this.showButton = false;
    }
    if (this.loadMoreArr.length == total && this.loadMoreArr.length != 0)
      this.showButton = false;
  }


  close(content: any) {

    if (this.communityName != '') {
      this.Title = "Select Ministry Headquarters";
      this.showError = false;
      this.loading = false;
      this.staticButton = false;
      this.modalService.dismissAll();
      this.getCommunity(0);
      this.modalService.open(content, { scrollable: true });

    } else if (this.affilatedById != "") {
      this.showError = false;
      this.loading = false;
      this.staticButton = false;
    } else {
      this.showError = true;
      this.modalError = 'Please Select one of them.';
    }
  }

  selectItem(e, props) {
    // Toggle selection for faith or community
    if (props.type == 'faith') {
      if (e.target.checked) {
        this.showError = false;
        this.clearValidtion('faith');
        this.faithid = props._id;
        this.form.get('faith').setValue(props._id);
        this.faithName = props.name;
      }
      return;
    }

    // Handle static options like Headquarters / Satellite Campus
    if (props.type == 'static') {
      // Radio behavior: selecting always sets the value
      this.communityName = props.name;

      if (props.name === 'Headquarters') {
        // No secondary modal needed
        this.staticButton = false;
        // Clear any selected parent HQs when switching to HQ
        this.selectedassociatedBy = [];
        this.form.get('associatedBy').setValue([]);
        // Clear validation for associatedBy
        this.form.get('associatedBy').clearValidators();
        this.form.get('associatedBy').updateValueAndValidity();
      }

      if (props.name === 'Satellite Campus') {
        // Show the Select button that opens the HQ listing modal
        this.staticButton = true;
        // Require associatedBy when Satellite is chosen
        this.form.get('associatedBy').setValidators([Validators.required]);
        this.form.get('associatedBy').updateValueAndValidity();
      }

      this.showError = false;
      return;
    }

    if (props.type == 'community') {
      const checked = e.target.checked;
      const id = props._id;
      const idx = this.selectedassociatedBy.findIndex((x) => x.community === id);
      if (checked && idx === -1) {
        this.selectedassociatedBy.push({ community: id, isApproved: false });
      } else if (!checked && idx > -1) {
        this.selectedassociatedBy.splice(idx, 1);
      }

      // Update form control with the latest array
      this.form.get('associatedBy').setValue([...this.selectedassociatedBy]);

      // If Satellite Campus is selected among options, allow opening HQ modal
      if (props.name == 'Satellite Campus' && checked) {
        this.staticButton = true;
        this.communityName = props.name;
      }

      // Clear/show errors based on selection
      this.showError = this.selectedassociatedBy.length === 0;
      if (this.showError) {
        this.modalError = 'Please select at least one ministry.';
      }
      return;
    }
  }

  getErrorImage(event) {
    this.authService.geterrorImage(event);
  }

  isCommunitySelected(id: string): boolean {
    return this.selectedassociatedBy.some((x) => x.community === id);
  }

  uploadBanner(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('image', file, file.name);
      formData.append('imageType', 'coverImage');
      this.authService.upload(formData).subscribe(
        (data) => {
          this.coverPhoto = environment.basePath + data['data'].url;
          this.form.get('coverPhoto').setValue(this.coverPhoto);
        },
        (error) => {
          this.authService.successMessage(error.error.message, 'error');
        }
      );
    } else {
      this.authService.successMessage('Error', 'error');
    }
  }

  uploadProfile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('image', file, file.name);
      formData.append('imageType', 'profilePic');
      this.authService.upload(formData).subscribe(
        (data) => {
          this.profilePic = environment.basePath + data['data'].url;
          this.form.get('photo').setValue(this.profilePic);
        },
        (error) => {
          this.authService.successMessage(error.error.message, 'error');
        }
      );
    } else {
      this.authService.successMessage('Error', 'error');
    }
  }

  checkImage(usr) {
    if (usr) {
      let pathArray = usr.split('/');
      let protocol = pathArray[0];
      let host = pathArray[2];
      let url = protocol + '//' + host + '/';
      if (
        url == environment.basePath &&
        (protocol == 'https:' || protocol == 'http:')
      ) {
        return usr;
      } else if (protocol == 'uploads') {
        return environment.basePath + usr;
      } else {
        return usr;
      }
    }
  }

  setUrl(photo: string) {
    if (photo != null) {
      const [baseUrl, imgUrl] = photo.split('uploads');
      return `https://services.ravel.faith/uploads/${imgUrl}`;
      // return `http://localhost:9000/uploads${imgUrl}`
    }
    return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg'
  }

  renderImage(data: any) {
    console.log('data-------=', data)
    if (data !== null) {
      let imgUrl = this.authService.spilturl(data);
      console.log('000000000', imgUrl)
      return imgUrl;
    } else {
      return 'assets/images/church.jpeg'
    }
  }

  hasError(event, key) {
    const formControl = this.form.get(key);
    if (key == 'contactNo') {
      this.phoneError = this.error(formControl.value, event);
    }
    if (key == 'HotLinkContactNo') {
      this.thirdPhone = this.error(formControl.value, event);
    }
  }

  error(value, event) {
    if (value != '' && value != undefined && event == false) {
      return false;
    } else {
      return true;
    }
  }

  telInputObject(event) { }

  onCountryChange(event) { }

  getNumber(event, key) {
    this.form.get(key).setValue(event);
  }

  getCommunityData() {
    let skip = 0;
    let limit = 10000;
    this.authService.getAllCommunityListing(skip, limit).subscribe((res: any) => {
      this.allCommunityListing = res.items;
    }
      , (error: any) => {
        console.error(error);
      }
    )
  }



  search(event: any) {
    setTimeout(() => {
      this.searchTerm = event.target.value;
      this.getCommunity(0);
    }, 1000)
  }

  isChristianDisabled(faith: any): boolean {
    return faith.name === 'Christian';
  }

  noWhitespaceOrSpecialCharacter(control) {
    if (control.value && (control.value.trim() !== control.value || !/^[a-zA-Z0-9]*$/.test(control.value))) {
      return { 'whitespaceOrSpecialCharacter': true };
    }
    return null;
  }

  changeFaith(event: any) {
    this.form.controls['faith1Name'].setValue(event?.name || '');
    this.selectedBranch = '';
    this.selectedDenomination = '';

    const filteredFaith = this.faithList?.find((item: any) => item._id === event?._id);
    this.faithBranches = filteredFaith && filteredFaith.subcategory ? filteredFaith.subcategory : [];

    // Clear lower levels when faith changes
    this.faithDenominations = [];
    this.form.controls['subFaith'].setValue(null);
    this.form.controls['subFaithSub'].setValue(null);
    this.form.controls['faith2Name'].setValue('');
    this.form.controls['faith3Name'].setValue('');
  }

  changeSubFaith(event: any) {
    this.form.controls['faith2Name'].setValue(event?.name || '');
    const filteredFaith = this.faithBranches?.find((item: any) => item._id === event?._id);
    this.faithDenominations = filteredFaith && filteredFaith.subcategory ? filteredFaith.subcategory : [];

    // Clear denomination when branch changes
    this.selectedDenomination = '';
    this.form.controls['subFaithSub'].setValue(null);
  }

  changeSubFaith2(event: any) {
    this.form.controls['faith3Name'].setValue(event?.name || '');
  }
}
